import { css } from '@emotion/core';
import { variables, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;

// NOTE: styles wrapped component
export var viewToggle = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";text-decoration:none;background:none;cursor:pointer;border:0;&:focus{outline:none;}");
export var viewToggleIcon = /*#__PURE__*/css("color:", colors.neutral.base.default, ";vertical-align:middle;");
export var viewToggleText = /*#__PURE__*/css("margin-left:4px;font-size:", variables.font.smallFontSize, ";font-weight:", variables.font.headingFontWeight, ";");